import HomepageScreen from "features/Homepage";

const Homepage = () => {
  return <HomepageScreen />;
};

export default Homepage;
